module.exports = __webpack_public_path__ + "img/toVerscanButton.7e23f025.svg";